export const generateRandomString = (length = 6) =>
  Math.random()
    .toString(20)
    .slice(2, length + 2)

export const getArrowClassName = (name: string, type: 'prev' | 'next' = 'prev') => {
  return `slider_${name}_${type.toString()}`
}
